import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useRef } from "react";
import axios from 'axios'
import { Auth } from "../../../config/aws-exports";
// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { updateCompanyProfileDetails, updateImpersonationIdId, updateUserInfo } from "../../../redux/actions";
import { fetchUserProfile } from "../../../redux/actions";

import { getCookie, setCookie } from "../../../shared/helpers";
import { useHistory, useLocation } from "react-router-dom";
import { addUpdateUserDeviceDeatils } from "../../../API/API";
// import history from "../../../routes/history";

const AuthSuccess = (props) => {
  const history = useHistory();
  const location = useLocation().search;
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const dispatch = useDispatch();
  const userId = new URLSearchParams(location).get("userId");
  const adminToken = new URLSearchParams(location).get("token");
  const redirectUrl = new URLSearchParams(location).get("redirectUrl");

  if (redirectUrl) {
    localStorage.setItem("redirectUrl", redirectUrl);
  }
  const updateAsEmployer = () => {
    dispatch(
      updateCompanyProfileDetails({
        AccountTypeCode: "EMP",
        Source:"skillradar",
      })
    );
  };
  const getUserDeviceDetails = (IPAddress) => {
    const userAgent = navigator.userAgent;
    let DeviceType, DeviceName, AdditionalInfo;

    if (/Windows/i.test(userAgent)) {
      DeviceType = "Desktop";
      DeviceName = "Windows";
      AdditionalInfo = userAgent;
    } else if (/Macintosh/i.test(userAgent)) {
      DeviceType = "Desktop";
      DeviceName = "Mac";
      AdditionalInfo = userAgent;
    } else if (/Android/i.test(userAgent)) {
      DeviceType = /Mobile|Tablet/i.test(userAgent) ? "Mobile" : "Tablet";
      DeviceName = userAgent.match(/(Android [\d.]+)/)?.[1];
      AdditionalInfo = userAgent;
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      DeviceType = /iPad/i.test(userAgent) ? "Tablet" : "Mobile";
      DeviceName = userAgent.match(/(iPhone|iPod|iPad);.*CPU.*OS (\d+)/i)?.[1];
      AdditionalInfo = userAgent;
    } else {
      DeviceType = "Unknown";
      DeviceName = userAgent;
      AdditionalInfo = userAgent;
    }

    return {
      DeviceName,
      DeviceType,
      AdditionalInfo,
      IPAddress,
    };
  };

  useEffect(async () => {
    const getIpAddress = async () => {
      const response = await axios.get("https://api.ipify.org?format=json");
      if (response?.data) {
        addUpdateUserDeviceDeatils(getUserDeviceDetails(response?.data?.ip))
      }
    };

    getIpAddress()

    let session = null;
    try {
      if (userId && adminToken) {
        // superadmin impersonating user — the admin token is already verified, so record
        // an empty source (never "skillradar") and drop the previous session's profile
        // and verification state, otherwise they gate this entry into /verify-email
        localStorage.setItem("cognitoSource", "");
        localStorage.removeItem("emailVerified");
        localStorage.removeItem("userProfile");
        setCookie("token", adminToken, true);
        setCookie("impersonationid", userId);
        props.updateImpersonationId(userId);
        props.sendAuthToken(adminToken);
        props.profileDetails({ token: adminToken, impersonationId: userId });
      } else if (getCookie("token") !== null && getCookie("token").length > 0) {
        const token = getCookie("token");
        props.profileDetails(token);
        // dispatch(fetchUserProfile(token))
        // props.sendAuthToken(token); linked token already save at this point in reducer
      } else if ((session = await Auth.currentSession())) {
        // const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();
        setCookie("token", token);
        props.profileDetails(token);
        // dispatch(fetchUserProfile(token))
        props.sendAuthToken(token);
      } else {
        history.push("/login");
      }
    } catch (err) {
      history.push("/login");
    }
  }, []);

  
  useEffect(() => {
    if (profile?.AccountTypeCode == "TAL" && props?.token?.authToken) {
      window.location.replace("/talent/auth");
    }
  }, [profile])

  useEffect(() => {
    const wizardFlowRaw = profile?.WizardFlow ?? profile?.Profiles?.WizardFlow;
    window.name = "talentemployer";

    // return;
    if (profile?.EmailAddress) {
      const wizardFlow = Number(wizardFlowRaw);
       if (profile?.MasterAccountId != null) {
        setCookie('finishProfile', 'true')
        updateAsEmployer();
        history.push('/employerdashboard');
      } else if (wizardFlow === 601) {
        history.push("/about-yourself");
        return;
      } else if (wizardFlow === 602) {
        history.push("/about-your-company");
        return;
      } else if (wizardFlow === 610) {
        history.push("/create-your-first-job");
        return;
      } else if (wizardFlow === 1000) {
        // window.name = "employerdashboard";
        setCookie("finishProfile", "true");
        history.push("/employerdashboard");
        return;
      } else if (profile.AccountTypeCode == null) {
        window.name = "about-yourself";
        setCookie('finishProfile', '')
        updateAsEmployer();
        window.location.replace("/employer/about-yourself");
      } else if (profile?.Professions?.ProfessionCode == null) {
        window.name = "about-yourself";
        setCookie('finishProfile', '')
        window.location.replace("/employer/about-yourself")
      } else if (profile.Profiles.CompanyName == null) {
        window.name = "about-yourself";
        setCookie('finishProfile', '')
        window.location.replace("/employer/about-yourself");
      } else if (profile.Profiles.FirstName == null) {
        window.name = "personaldetails";
        history.push("/personaldetails");
      } else if (localStorage.getItem("redirectUrl")) {
        
        let newRedirectedUrl = localStorage.getItem("redirectUrl");
        if (newRedirectedUrl.includes("messages")){
          newRedirectedUrl = newRedirectedUrl.replace("messages", "conversations")
        }
        localStorage.removeItem("redirectUrl");
        setCookie('finishProfile', 'true')
        history.push(newRedirectedUrl);
      } else {
        window.name = "employerdashboard";
        setCookie('finishProfile', 'true')
          history.push('/employerdashboard')
      }
    }
  }, [props.user, profile]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        fontSize: "2.5rem",
        margin: "40vh 0",
        color: "#118936",
      }}
    >
      <LoadingOutlined />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.profileReducer.user,
    error: state.authReducer.error,
    token: state.authReducer.user,
    // userProfile: state.profileReducer.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendAuthToken: (params) => {
      dispatch(updateUserInfo(params)); // action dispatched
    },
    profileDetails: (params) => {
      dispatch(fetchUserProfile(params)); // action dispatched
    },
    updateImpersonationId: (token) => {
      dispatch(updateImpersonationIdId(token)); // action dispatched
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthSuccess);
